import { JwtHelper } from 'angular2-jwt';
import { Participante } from '../participantes/participante';

export class Usuario{
  id: number;
  nome: string;
  grupo_ids: number[];
  perfis: string[];
  perfil_ids: number[];
  tipo_documento: string;
  numero_documento: string;
  password: string;
  password_confirm: string;
  login: string;
  participante: Participante;

  constructor(){
    let jwtHelper: JwtHelper = new JwtHelper();
    let token = localStorage.getItem('token');

    if(token !== null){
      let tokenDecode = jwtHelper.decodeToken(token);
      this.id = tokenDecode.id;
      this.nome = tokenDecode.nome;
      this.perfis = tokenDecode.perfis;
      this.grupo_ids = tokenDecode.grupos;
    }

    this.participante = new Participante();

  }

}



// WEBPACK FOOTER //
// ./src/app/usuario/usuario.ts